<!--
 * @Description: 帮助按钮
 * @Author: cooky
 * @Date: 2021-03-02 16:41:47
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-10 15:07:49
-->
<template>
  <img src="@/static/assets/ui/pc/icon-help.png" alt="" @click="handleHelp">
</template>
<script>
export default {
  name: 'SHelp',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleHelp () {
      this.$info({
        content: () => {
          return (
            <div style="text-align: left;white-space: pre-wrap;">
              {this.text}
            </div>
          )
        },
        okText: this.$t('ok')
      })
    }
  }
}
</script>>
<style lang="less" scoped>
    img {
        cursor: pointer;
    }
    @media screen and (max-width: 750px) {
        img {
            width: 6.4rem;
        }
    }
</style>
